import styled, { css } from "styled-components";
import Cleave from "cleave.js/react";
import PhoneInput from "react-phone-number-input/input";
import { Flex } from "../Grid";
const hideArrowsMixin = css `
  input[type="number"] {
    -moz-appearance: textfield;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
export const InputWrapperContainer = styled.span `
  position: relative;
  display: inline-block;
  width: ${({ width }) => width || "100%"};
`;
export const InputContainer = styled.div `
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: ${({ disabled, noDisabledBackground }) => disabled && !noDisabledBackground ? "#F3F3F3" : "transparent"};
  border: 1px solid ${({ isFocused, error }) => isFocused ? "#9D87F1" : error ? "#F1274C" : "#E3E3E3"};
  border-radius: 0.5rem;
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "2.75rem"};
  outline: ${({ isFocused }) => isFocused ? "4px solid #CEC3F8" : undefined};

  &:hover {
    border-color: ${({ disabled, error }) => !(disabled || error) && "#9F9F9F"};
  }

  ${({ hideArrows }) => hideArrows && hideArrowsMixin}
`;
export const InputPrefix = styled.div `
  display: inline-flex;
  padding: 0 0 0 0.75rem;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
`;
export const InputSuffix = styled.div `
  display: inline-flex;
  padding: 0 0.5rem 0 0;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
`;
export const InputField = styled.input `
  width: 100%;
  border: none;
  outline: none;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: ${({ error }) => error ? "#F1274C" : "#000000"};
  padding: 0 1rem;
  background-color: transparent;
  
  &[disabled] {
    color: #9F9F9F;
  }

  &::placeholder {
    color: ${({ error }) => error ? "#F1274C" : "#9F9F9F"};
  }
`;
export const StyledCleave = styled(Cleave) `
  width: 100%;
  border: none;
  outline: none;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: ${({ error }) => error ? "#F1274C" : "#000000"};
  padding: 0 1rem;
  background-color: transparent;

  &[disabled] {
    color: #9F9F9F;
  }

  &::placeholder {
    color: ${({ error }) => error ? "#F1274C" : "#9F9F9F"};
  }
`;
export const StyledPhoneInput = styled(PhoneInput) `
  width: 100%;
  border: none;
  outline: none;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: ${({ error }) => error ? "#F1274C" : "#000000"};
  padding: 0 1rem;
  background-color: transparent;

  &[disabled] {
    color: #9F9F9F;
  }

  &::placeholder {
    color: ${({ error }) => error ? "#F1274C" : "#9F9F9F"};
  }
`;
export const InputLabel = styled(Flex) `
  align-items: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #9F9F9F;
  margin-bottom: 0.5rem;
`;
export const InputErrorMessage = styled.div `
  position: absolute;
  color: #F1274C;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  margin-top: 0.25rem;
`;
export const InputSliderContainer = styled.div `
  display: inline-block;
  width: 100%;
  
  ${".rc-slider-mark"} {
    & > ${".rc-slider-mark-text"} {
      &:first-child {
        transform: translateX(0%) !important;
      }

      &:last-child {
        position: absolute;
        transform: translateX(-100%) !important;
        white-space: nowrap;
      }
    }
  }
`;
export const InputMarksContainer = styled(Flex) `
  position: absolute;
  bottom: -1.625rem;
  justify-content: space-between;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #9F9F9F;
  padding: 0 0.5rem;
`;
